export function getPageScrollEl() {
  return document.getElementById('app')
}

const scrollTo = function (pos) {
  const scrollEl = getPageScrollEl()
  scrollEl.scrollTop = pos
}

export default {
  scrollTo,
  scrollToEl() {
  },
  scrollToQuestion(question) {
    let el
    for (const element of document.getElementsByClassName('question-item')) {
      if (element.getAttribute('data-id') === question.q_id.toString()) {
        el = element
        break
      }
    }
    if (!el) return
    scrollTo(el.offsetTop)
  }
}
